import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";
import Table from "react-bootstrap/Table"; // You are using Bootstrap's Table

const ShgMembersPage = () => {
  const navigate = useNavigate();
  const { shgId } = useParams();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false); // control for collapse/expand
  const Api = process.env.REACT_APP_API;

  const LOCAL_KEY = `ShgMemberDataCache_${shgId}`;

  const saveToLocalCache = (data) => {
    const cache = {
      data,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(LOCAL_KEY, JSON.stringify(cache));
  };

  const loadFromLocalCache = () => {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : null;
  };

  const fetchMemberDetails = async (shgId) => {
    console.log("inside fetchmembers", shgId);
    try {
      const config = Authorization(); // Assuming this returns headers including auth token
      const response = await fetch(`${Api}/api/shgMember/members`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...config.headers, // Spread any headers from Authorization
        },
        body: JSON.stringify({ shgId }),
      });

      const data = await response.json();
      setMembers(data.members);
      saveToLocalCache(data.members);
    } catch (error) {
      console.log("Error fetching members", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached?.data) {
      setMembers(cached.data);
      setLoading(false);
    } else {
      fetchMemberDetails(shgId); // ✅ PASS the shgId
    }
  }, [shgId]);

  if (loading) return <Preloader loading={true} />;
  if (!Array.isArray(members) || members.length === 0)
    return <p className="m-4 text-danger">No members found.</p>;

  return (
    <div>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              setLoading(true);
              fetchMemberDetails(shgId);
            }}
          >
            🔄 Refresh Now
          </button>
        </div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="card bg-gradient-success card-img-holder text-white mb-4">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-normal mb-3">SHG Members</h4>
          <h3 className="font-weight-bold">
            {members.length > 0 ? members[0].shg.name : "Loading..."}
          </h3>
        </div>
      </div>

      {/* Collapsible VFC group */}
      <div className="mt-3">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: "white",
            padding: "10px",
            borderRadius: "5px",
          }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <h5 className="mb-0">SHG: {members[0].shg.name}</h5>
          <span style={{ fontSize: "1.2rem" }}>{expanded ? "−" : "+"}</span>
        </div>

        {expanded && (
          <Table striped bordered hover className="mt-2">
            <thead>
              <tr>
                <th>#</th>
                <th>Member Name</th>
                <th>Gender</th>
                <th>VFC Name</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member, index) => (
                <tr key={member._id}>
                  <td>{index + 1}</td>
                  <td
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate(`/drill/single-shg/members/${member.member._id}`)
                    }
                  >
                    {member.member.name}
                  </td>

                  <td>{member.member.gender}</td>
                  <td>{member.shg.vfcName}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default ShgMembersPage;
